import React, { useEffect, useState } from 'react';
import botImg from '../../../assets/images/bot-head.svg'
import { formatText,linkify } from '../../utility/MessageFormatter';
import PdfViewer from "./PdfViewer";

function BotMessage({message, time, botInfo,prefLang,messageArray,showFullImage,scrollToBottom}) {
    const messageDetails = messageArray?.template?.template?.elements
    const [showPdfView, setShowPdfView]= useState(false)

    useEffect(()=>{
        setTimeout(() => {
            setShowPdfView(true)
        }, 1000);
    },[])
    return(
        <div className="user-msg-wrapper">
            <div className="message-wrapper">
                <div className="message-block">
                    <small className="message-agent">{botInfo?.data?.mobileAppConfig?.step23 ? botInfo?.data?.mobileAppConfig?.step23?.[prefLang] : 'You'}</small>
                    {
                        messageDetails?.attachment ?
                            messageDetails?.attachment?.url?.split('.').pop() == "pdf" ?
                                showPdfView && <PdfViewer url={messageDetails?.attachment?.url} type={messageDetails?.attachment?.type} time={messageDetails?.attachment?.time} scrollToBottom={scrollToBottom} createdAt={message?.updatedAt} expierMessage={messageDetails?.attachment?.expierMessage} fileName={messageDetails?.attachment?.name} />
                            :
                                <img src={messageDetails?.attachment?.url} className="attachment-image" onClick={() => showFullImage(messageDetails?.attachment?.url)} />
                        :
                            <div dangerouslySetInnerHTML={{ __html: linkify(formatText(message))}}></div>
                    }
                    <small className="message-timing">{time}</small>
                </div>
                <div className="chat-nib">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0001 7.31951C14.2679 14.3046 19.7083 17.8814 21.2749 18.5528C16.7608 19.3735 12.781 18.617 9.63188 17.3304C7.86691 18.8954 5.54446 19.8457 3.00005 19.8457H5.34058e-05V0.845703H13.0001V7.31951Z" fill="var(--user-bubble-bg)"/>
                    </svg>
                </div>
            </div>
            {/* <img src={botImg} className="user-img" alt="user reply image"/> */}
        </div>
    )
}
export default BotMessage;
